<template>
  <div>
    <v-tabs
    v-model="tab"
    flat
    background-color="primary"
    dark
    height="40"
    grow
    >
    <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`" @change="refreshTab(tabitem)">
      {{ tabitem }}
    </v-tab>
  </v-tabs>
  <v-container class="pa-1" grid-list-md :key="pageRefKey">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs-items v-model="tab">
          <v-tab-item :key="0" value="tab-0" v-if="lAction === 'view'">
            <v-layout class="pa-1" row wrap>
              <v-flex xs12 sm6>
                <v-tabs v-model="attTab" show-arrows>
                  <v-tab v-for="(attitem, n) in attTabItems" :key="n" :href="`#tab-${n}`" @click="loadAttSummary(attitem, filter.billable)">
                    {{attitem}}
                  </v-tab>
                </v-tabs>
              </v-flex>
              <v-flex xs12 sm6 v-if="attTab === 'tab-3'">
                <v-layout row wrap class="ml-2">
                  <v-flex xs5>
                    <v-dialog ref="dlgPeriodFrom"
                    persistent v-model="dlgPeriodFrom"
                    max-width="290px"
                    :return-value.sync="filter.from_dt"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator" label="From"
                      v-model="filter.from_dt" append-icon="mdi-calendar-today"
                      readonly clearable hide-details
                      v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="filter.from_dt" scrollable
                    first-day-of-week="1"
                    >
                    <v-spacer></v-spacer>
                    <v-btn text @click="dlgPeriodFrom = false">Cancel</v-btn>
                    <v-btn text color="accent" @click="$refs.dlgPeriodFrom.save(filter.from_dt)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs5>
                <v-dialog ref="dlgPeriodTo"
                persistent v-model="dlgPeriodTo"
                max-width="290px"
                :return-value.sync="filter.to_dt"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator" label="To"
                  v-model="filter.to_dt" append-icon="mdi-calendar-today"
                  readonly clearable hide-details
                  v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.to_dt" scrollable
                first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn text @click="dlgPeriodTo = false">Cancel</v-btn>
                <v-btn text color="accent" @click="$refs.dlgPeriodTo.save(filter.to_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs2 class="text-center">
            <v-btn fab small class="accent" @click.native="loadAttSummary('month/period', filter.billable)">Go</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs6 v-if="attTab !== 'tab-3' && $vuetify.breakpoint.smAndUp">
      </v-flex>
      <v-flex xs12 sm4 class="mt-2">
        <v-combobox
        class="title"
        v-model="chosenCommPair"
        label="Community"
        :items="commList"
        item-text="comm_name"
        item-value="comm_id"
        clearable
        hide-details
        @input="chosenCommPair ? loadBasedOnchosenComm() : ''"
        ></v-combobox>
      </v-flex>
      <v-flex xs12 sm4>
        <v-select
        v-model="filter.vendor_list"
        label="Vendor filter"
        :items= "vendors"
        item-value="vendor_id"
        item-text="vendor_name"
        placeholder="All"
        clearable
        chips
        multiple
        hide-details
        @input="loadAttSummary(filter.current_period)"
        return-object
        ></v-select>
      </v-flex>
      <v-flex xs12 sm4 class="text-right">
        <v-btn :class="$vuetify.breakpoint.smAndUp ? 'mt-3' : 'mt-0'" @click="showAttLog()">View {{filter.current_period}}'s Log</v-btn>
      </v-flex>
      <v-flex xs12 class="py-2 text-right" v-if="shifts.length > 0">
        <span class="mr-1" v-for="(chip, index) in billableChip" :key="index">
          <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="loadAttSummary(filter.current_period, chip)" :class="filter.billable === chip ? 'info white--text' : ''">
            {{chip}}
          </v-chip>
        </span>
      </v-flex>
      <!-- for every shift -->
      <v-flex xs6 sm3 v-for="(shift, i) in shifts" :key="i" class="text-center">
        <v-card @click.native="showShift(shift.shift_id)" :class="shift.shift_id === lCurrentShiftId ? 'accent lighten-1 elevation-10' : ''" >
          <v-card-title class="pa-2 grey lighten-4">
            <div class="title primary--text">{{$vuetify.breakpoint.smAndUp ? shift.shift_abbr : shift.shift_abbr.substring(0,10)}}</div>
            <v-spacer></v-spacer>
            <v-btn icon small class="ma-0" @click="showShiftDet(shift.shift_id)"><v-icon>mdi-open-in-new</v-icon></v-btn>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-layout row wrap class="subheading black--text">
              <v-flex xs12>
                <div class="display-1">{{shiftSummary[shift.shift_id].attAve >= 0 ? (shiftSummary[shift.shift_id].attAve + '%') : '-'}}</div>
                <div class="caption grey--text" v-if="shiftSummary[shift.shift_id].attAve > 100">
                  It is more than 100% due to SBy/OT
                </div>
              </v-flex>
              <v-divider class="ma-1"></v-divider>
              <v-flex xs12>
                <div class="green--text lighten-2">
                  Present
                </div>
                <div>
                  <span class="display-1">{{shiftSummary[shift.shift_id].totPresent}}</span>/<span class="title">{{shiftSummary[shift.shift_id].totStaff}}</span>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-card flat class="grey lighten-4">
                      <div class="info--text grey lighten-3">
                        Leave/Ab
                      </div>
                      <div>
                        <span class="title">{{shiftSummary[shift.shift_id].totAbsent + shiftSummary[shift.shift_id].totLeave}}</span>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card flat class="grey lighten-4">
                      <div class="info--text grey lighten-3">
                        Weekoff
                      </div>
                      <div>
                        <span class="title">{{shiftSummary[shift.shift_id].totWO}}</span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-card flat class="grey lighten-4">
                      <div class="info--text grey lighten-3">
                        SBy/OT
                      </div>
                      <div>
                        <span class="title">{{shiftSummary[shift.shift_id].totOT}}</span>
                      </div>
                    </v-card>
                  </v-flex>
                  <v-flex xs6>
                    <v-card flat class="grey lighten-4">
                      <div class="info--text grey lighten-3">
                        {{($vuetify.breakpoint.smAndUp ? 'Pending' : 'Pen')}}<span class="caption"> In|Out</span>
                      </div>
                      <div>
                        <span :class="shiftSummary[shift.shift_id].totNotYetIn ? 'red--text title' : 'title'">{{shiftSummary[shift.shift_id].totNotYetIn}}</span>
                        <span class="grey--text">|</span>
                        <span :class="shiftSummary[shift.shift_id].totNotYetOut ? 'warning--text title' : 'title'">{{shiftSummary[shift.shift_id].totNotYetOut}}</span>
                      </div>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="pa-2 grey">
            <div class="title white--text">Key Staffs [{{lCurrentShift}}]</div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp ? keyStaffHeadSm : keyStaffHead"
            :items="keyStaffs"
            hide-default-footer
            :mobile-breakpoint="0"
            :sort-by="['att_dt', 'staff_role', 'staff_name']"
            multi-sort
            disable-pagination
            >
            <template slot="item" slot-scope="props">
              <tr :class="props.item.attendance ? '' : 'red--text'">
                <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ handy.formatDBDate(props.item.att_dt) }}</td>
                <td class="pa-3">{{ props.item.staff_role }}</td>
                <td class="pa-3">{{ props.item.staff_name }}</td>
                <td class="pa-3">{{ props.item.staff_mobile }}</td>
                <td class="pa-3">{{ props.item.attendance ? props.item.attendance : 'Pending' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" :class="'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')">{{ props.item.standby }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.check_in ? handy.formatDBDateTime(props.item.check_in) : '-' }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.check_out ? handy.formatDBDateTime(props.item.check_out) : '-' }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</v-tab-item>
<v-tab-item :key="1" value="tab-1" v-if="lAction === 'view'">
  <v-layout row wrap>
    <v-flex xs12>
      <v-card flat>
        <v-card-text class="grey lighten-4 pa-2">
          <v-layout row wrap>
            <v-flex xs7 sm4>
              <v-select
              v-model="filter.vendor_list"
              label="Vendor"
              :items= "vendors"
              item-value="vendor_id"
              item-text="vendor_name"
              placeholder="All"
              clearable
              multiple
              hide-details
              return-object
              ></v-select>
            </v-flex>
            <v-flex xs5 sm2>
              <v-select
              v-model="filter.role_list"
              label="Services"
              :items="roles"
              item-text="staff_role"
              item-value="staff_role_id"
              placeholder="All"
              hide-details
              multiple
              clearable
              return-object
              ></v-select>
            </v-flex>
            <v-flex sm1 v-if="$vuetify.breakpoint.smAndUp">
            </v-flex>
            <v-flex xs5 sm2>
              <v-dialog ref="dlgFromDt"
              persistent v-model="dlgFromDt"
              max-width="290px"
              :return-value.sync="filter.from_dt"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator" label="From"
                v-model="filter.from_dt" append-icon="mdi-calendar-today"
                readonly clearable
                hide-details
                v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="filter.from_dt"
              first-day-of-week="1"
              >
              <v-spacer></v-spacer>
              <v-btn text @click="dlgFromDt = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.dlgFromDt.save(filter.from_dt)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs5 sm2>
          <v-dialog ref="dlgToDt"
          persistent v-model="dlgToDt"
          max-width="290px"
          :return-value.sync="filter.to_dt"
          >
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="To"
            v-model="filter.to_dt" append-icon="mdi-calendar-today"
            readonly clearable
            hide-details
            v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="filter.to_dt"
          first-day-of-week="1">
          <v-spacer></v-spacer>
          <v-btn text @click="dlgToDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgToDt.save(filter.to_dt)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs2 sm1 class="text-right">
      <v-btn
      fab small
      class="accent"
      @click.native="refreshAttReport(lRep.agreedHeadCount, 'Billable')">
      Go
    </v-btn>
  </v-flex>
</v-layout>
</v-card-text>
</v-card>
</v-flex>
<v-flex xs12>
  <v-card flat>
    <v-card-title class="pt-2">
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <span class="title font-weight-bold">Attendance Summary</span>
          <div class="body-2">For period of {{filter.rep_days}} days</div>
        </v-flex>
        <v-flex xs7 sm3 class="pb-0">
        <span v-for="(chip, index) in billableChip" :key="index">
          <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="refreshAttReport(null, chip)" :class="enableChip === chip ? 'info white--text' : ''">
            {{chip}}
          </v-chip>
        </span>
      </v-flex>
      <v-flex xs5 sm3 class="py-1 my-0">
        <v-checkbox
        v-model="lRep.agreedHeadCount"
        class="py-1 my-0"
        label="Show Agreed"
        hide-details
        style="text-align:center; font-size: 8px"
        @change="refreshAttReport(lRep.agreedHeadCount, enableChip)"
        >
        <template v-slot:label>
          <span style="font-size: 14px">Show Agreed</span>
        </template>
        </v-checkbox>
        </v-flex>
        <v-flex xs12 class="text-xs-right pa-0">
          <v-download-as
          :headers="lRep.agreedHeadCount ? repHeadCountSm : repHeadSm"
          :items="attReport"
          title="Attendance Summary"
          :fontsize="8"
          :subtitle="(filter.vendor_list && filter.vendor_list.length ? filter.vendor_list.map(rec => rec.vendor_name).join() + ' - ' : '') + (filter.role_list && filter.role_list.length ? filter.role_list.map(rec => rec.staff_role).join() : '') + (' [' + handy.formatDate(filter.from_dt) + ' to ' + handy.formatDate(filter.to_dt) + '] (' + filter.rep_days + ' days)')"
          ></v-download-as>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="($vuetify.breakpoint.smAndUp ? (lRep.agreedHeadCount ? repHeadCountSm : repHeadSm) : repHead)"
      :items="attReport"
      hide-default-footer
      :mobile-breakpoint="0"
      class="elevation-3"
      sort-by="staff_role"
      disable-pagination
      :search="search">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.staff_role }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_present }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_wo }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_holiday }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_ot }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_leave  }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp">{{ props.item.tot_absent }}</td>
          <td class="pa-2 accent lighten-3 text-center">{{ props.item.tot_contracted }}</td>
          <td class="pa-2 green lighten-3 text-center">{{ props.item.tot_billable }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
<v-flex xs12 class="mt-2">
  <v-card flat>
    <v-card-title class="pt-2">
      <v-layout row wrap>
        <v-flex xs12 sm2>
        <span class="subtitle-1 font-weight-bold">Attendance Detail</span>
      </v-flex>
      <v-flex xs12 sm7 class="text-xs-right pt-0">
        <v-radio-group v-model="filter.det_type" :mandatory="true" row @change="refreshAttReportDet(filter.billable)" hide-details>
          <v-radio value="date">
            <template v-slot:label>
              <span style="font-size: 15px;">Calendar View</span>
            </template></v-radio>
            <v-radio label="Staff View" value="staff">
              <template v-slot:label>
                <span style="font-size: 15px">Staff View</span>
              </template></v-radio>
            </v-radio>
            <v-radio label="Timesheet" value="timesheet">
              <template v-slot:label>
                <span style="font-size: 15px">Timesheet</span>
              </template></v-radio>
            </v-radio>
            <v-radio value="inOutSheet">
              <template v-slot:label>
                <span style="font-size: 15px;">In/Out Sheet</span>
              </template></v-radio>
            </v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 sm3 class="pt-3 text-right" v-if="attNonBill.tot_nonbillable_staff > 0">
          <span class="mr-1" v-for="(chip, index) in billableChip" :key="index">
            <v-chip class="mx-1" :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="refreshAttReportDet(chip)" :class="filter.billable === chip ? 'info white--text' : ''">
              {{chip}}
            </v-chip>
          </span>
        </v-flex>
        <v-flex xs6>
          <v-text-field
          class="pa-0 mt-1"
          append-icon="mdi-account-search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by role, name, etc.':'Search'"
          single-line
          hide-details
          v-model="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-download-as
          :headers="filter.det_type === 'staff' ? repDetStaffHeadSm : repDetCalHeadSm"
          :items="attReportDet"
          title="Attendance Detail"
          :subtitle="(filter.vendor_list && filter.vendor_list.length ? filter.vendor_list.map(rec => rec.vendor_name).join() + ' - ' : '') + (filter.role_list && filter.role_list.length ? filter.role_list.map(rec => rec.staff_role).join() : '') + (' [' + handy.formatDate(filter.from_dt) + ' to ' + handy.formatDate(filter.to_dt) + '] (' + filter.rep_days + ' days)')"
          :landscape="filter.det_type !== 'staff'"
          :fontsize="filter.det_type === 'timesheet' ? 6 : 7"
          :cellpadding="filter.det_type === 'timesheet' ? 0.25 : 1"
          legend="P-Present, W-Weeklyoff, H-Holiday, HD-Half Day, S-Standby, O-Overtime, L-Leave, A-Absent, Billable=P+W+H+S/O+L"
          ></v-download-as>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp ? (filter.det_type === 'staff' ? repDetStaffHeadSm : repDetCalHeadSm) : (filter.det_type === 'staff' ? repDetStaffHead : repDetCalHeadSm)"
      :items="attReportDet"
      hide-default-footer
      fixed-header
      height="450px"
      :mobile-breakpoint="0"
      class="elevation-3"
      :sort-by="['staff_role', 'staff_name']"
      multi-sort
      disable-pagination
      :search="search">
      <template slot="item" slot-scope="props">
        <tr style="border-bottom:1px solid gray">
          <td class="pa-2" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.staff_role }}</td>
          <td class="pa-2">{{ props.item.staff_name }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.vendor_emp_id }}</td>
          <td :class="'px-1 py-0 text-center ' + (calday.attendance.includes('P') ? 'green' : calday.attendance.includes('A') ? 'red' : calday.attendance.includes('W') ? 'yellow' : (calday.attendance.includes('CL') || calday.attendance.includes('SL') || calday.attendance.includes('EL')) ? 'grey' : calday.attendance.includes('HD') ? 'green lighten-2' : calday.attendance.includes('H') ? 'blue' : !calday.attendance ? 'red lighten-4' : 'grey lighten-2')" v-for="(calday, i) in props.item.calendar" :key="i">
            <span v-if="calday.attendance" :class="calday.attendance === '-' ? 'title' : ''"><b>{{ calday.attendance }}</b></span>
            <span class="display-1 red--text" v-else>.</span>
            <span class="caption" v-if="calday.att_detail"><br /><span v-for="(line, i) in calday.att_detail.split('\n')" :key="i">{{ line }}<br /></span></span>
          </td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_present }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_wo }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_holiday }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_ot }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_leave }}</td>
          <td class="pa-2 text-center" v-if="$vuetify.breakpoint.smAndUp || filter.det_type === 'date'">{{ props.item.tot_absent }}</td>
          <td v-if="filter.det_type === 'staff'" class="pa-2 accent lighten-3 pa-2 text-center">{{ props.item.tot_contracted }}</td>
          <td class="pa-2 green lighten-3 pa-2 text-center">{{ props.item.tot_billable }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-flex>
</v-layout>
</v-tab-item>
</v-tabs-items>

<v-row>
  <v-col cols="12">
    <v-container v-if="lAction === 'att-det'" class="pa-0">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="ma-1">
            <v-card-title class="title grey lighten-4 pb-0">
              Attendance ({{lCurrentShift}})
              <v-spacer></v-spacer>
              <v-btn small icon @click.native="lAction = 'view', search = ''"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <v-card-actions class="grey lighten-4 caption">
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    append-icon="mdi-account-search"
                    hide-details
                    v-model="search"
                    class="pa-0 ml-1"
                    placeholder="Search"
                    clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-download-as
                    :headers="attHeadSm"
                    :items="shiftSummary[lCurrentShiftId].detail"
                    title="Attendance Details"
                    :subtitle="lCurrentFrom + ' to ' + lCurrentTo + ' (' + lCurrentShift + ')'"
                    :landscape="true"
                    ></v-download-as>
                  </v-flex>
                </v-layout>
              </v-card-actions>
              <v-flex xs12 sm4 :class="attNonBill.tot_nonbillable_staff > 0 ? 'pt-3 pb-0' : ''" v-if="attNonBill.tot_nonbillable_staff > 0">
                <span class="mr-1" v-for="(chip, index) in billableChip" :key="index">
                  <v-chip :style="$vuetify.breakpoint.smAndUp ? '' : 'width:30%;'" small @click="refreshNonBillAttReportDet(chip)" :class="filter.billable === chip ? 'info white--text' : ''">
                    {{chip}}
                  </v-chip>
                </span>
              </v-flex>
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp ? attHeadSm : attHead"
              :items="filter.billable === 'Billable' ? shiftSummary[lCurrentShiftId].detail : nonBillshiftSummary[lCurrentShiftId]"
              hide-default-footer
              :search="search"
              :sort-by="['att_dt', 'staff_role', 'staff_name']"
              multi-sort
              disable-pagination
              :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr @click="prepareEditDet(props.item)" :class="((props.item.attendance !== 'Absent' && props.item.attendance !== 'Weekly Off' && props.item.attendance !== 'Holiday') || (props.item.standby || props.item.sby_temp_staff_name)) && props.item.check_in && !props.item.check_out ? 'warning--text' : (props.item.attendance ? '' : 'red--text')">
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ handy.formatDBDate(props.item.att_dt) }}</td>
                  <td class="pa-3">{{ props.item.staff_role }}</td>
                  <td class="pa-3">{{ props.item.staff_name }} ({{props.item.vendor_emp_id}})</td>
                  <td class="pa-3">{{ props.item.attendance ? props.item.attendance : 'Pending' }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" :class="'pa-3' + (props.item.sby_temp_staff_name ? ' red' : '')">{{ props.item.standby }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.check_in ? handy.formatDBDateTime(props.item.check_in) : '-' }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-3">{{ props.item.check_out ? handy.formatDBDateTime(props.item.check_out) : '-' }}</td>
                  <td class="pa-3">{{ props.item.effective_work_hours ? props.item.effective_work_hours + 'hrs': '-' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</v-col>
</v-row>

<v-container v-if="lAction === 'att-log'" class="pa-0">
  <v-layout row wrap>
    <v-flex xs12>
      <v-card class="ma-1">
        <v-card-title class="title grey lighten-4 pb-0">
          Attendance Log ({{handy.startWithUpper(filter.current_period)}})
          <v-spacer></v-spacer>
          <v-btn small icon @click.native="lAction = 'view', search = ''"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-card-actions class="grey lighten-4 caption">
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                append-icon="mdi-account-search"
                hide-details
                v-model="search"
                class="pa-0 ml-1"
                placeholder="Search"
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-download-as
                :headers="filterOfflineDev ? offlineDevHeadSm : attLogHeadSm"
                :items="filterOfflineDev ? offlineDevList : attLog"
                title="Attendance Log"
                :subtitle="lCurrentFrom + ' to ' + lCurrentTo"
                ></v-download-as>
              </v-flex>
              <v-flex xs12 class="text-right" v-if="offlineDevList.length">
                <v-chip small :class="'ma-1 pa-1' + (filterOfflineDev ? ' info white--text' : ' red--text') " @click="filterOfflineDev = !filterOfflineDev">{{offlineDevList.length}} offline deviations</v-chip>
              </v-flex>
            </v-layout>
          </v-card-actions>
          <v-data-table
          :headers="$vuetify.breakpoint.smAndUp ? (filterOfflineDev ? offlineDevHeadSm : attLogHeadSm) : (filterOfflineDev ? offlineDevHead : attLogHead)"
          :items="filterOfflineDev ? offlineDevList : attLog"
          :mobile-breakpoint="0"
          sort-by="log_dt"
          sort-desc
          hide-default-footer
          disable-pagination
          :search="search">
          <template slot="item" slot-scope="props">
            <tr>
              <td v-if="$vuetify.breakpoint.smAndUp || !filterOfflineDev">{{props.item.log_action}}</td>
              <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.log_mode_and_loc }}</td>
              <td v-if="$vuetify.breakpoint.smAndUp || !filterOfflineDev">{{ handy.formatDBDateTime(props.item.log_time) }}</td>
              <td>{{ props.item.staff_name }}</td>
              <td v-if="$vuetify.breakpoint.smAndUp && !filterOfflineDev">{{ props.item.staff_role }}</td>
              <td v-if="filterOfflineDev">{{ props.item.offline_deviation }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-container>

<!-- update attendance record -->
<v-dialog v-model="dlgAttDet" max-width="290px" scrollable>
  <v-flex xs12>
    <v-form ref="lForm" @submit.prevent="saveChanges()">
      <v-card flat>
        <v-card-title class="title pb-0">
          {{lAttDet.staff_name + ' (' + lCurrentShift + ')'}}
        </v-card-title>
        <v-card-text>
          <v-flex xs12>
            <v-select
            v-model="lAttDet.shift_id"
            label="Shift"
            :items="shifts"
            item-value="shift_id"
            item-text="shift_abbr"
            :error-messages="shiftNotRight && !shiftOverride ? 'Shift is not right based on check-in time' : ''"
            ></v-select>
          </v-flex>
          <v-flex xs12 v-if="shiftNotRight">
            <v-checkbox
            v-model="shiftOverride"
            label="Proceed with above shift">
          </v-checkbox>
        </v-flex>
        <v-flex xs12>
          <v-select
          v-model="lAttDet.attendance"
          label="Attendance"
          :items="['Present', 'Absent', 'Weekly Off', 'Half Day', 'Holiday', 'Present + OT', 'Weekly Off + OT', 'Holiday + OT', 'Present + RL', 'Casual Leave', 'Earned Leave', 'Sick Leave', 'Comp Off']"
          @input="loadNonBillStaffasSby(lAttDet)"
          ></v-select>
        </v-flex>
        <v-flex xs12 v-if="lAttDet.attendance === 'Absent' || (lAttDet.attendance && lAttDet.attendance.includes('Leave')) || lAttDet.attendance === 'Weekly Off' || lAttDet.attendance === 'Holiday'">
          <v-combobox
          v-model="lAttDet.sby_vendor_emp_pair"
          label="Standby staff"
          :items="vendorStandby"
          item-text="emp_name_and_id"
          item-value="vendor_emp_id"
          clearable
          ></v-combobox>
        </v-flex>
        <v-flex xs12 v-if="lAttDet.attendance === 'Absent' || (lAttDet.attendance && lAttDet.attendance.includes('Leave')) || lAttDet.attendance === 'Weekly Off' || lAttDet.attendance === 'Holiday'">
          <v-text-field
          v-model="lAttDet.sby_temp_staff_name"
          label="Temporary Staff"
          hint="Staff deployed temporarily in case"
          persistent-hint
          clearable
          ></v-text-field>
        </v-flex>
        <v-row align="center">
          <v-col cols="7" class="py-0 pr-0">
            <v-dialog ref="dlgCheckIn"
            persistent v-model="dlgCheckIn"
            max-width="290px"
            :return-value.sync="lAttDet.checkInDt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="Check-in"
              v-model="lAttDet.checkInDt"
              append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lAttDet.checkInDt" scrollable
            first-day-of-week="1"
            :min="handy.formatDBDate(lAttDet.checkInMinDt)"
            :max="handy.formatDBDate(lAttDet.checkInMaxDt)"
            @change="GetCheckOutDate(lAttDet.checkInDt)"
            >
            <v-spacer></v-spacer>
            <v-btn text @click="dlgCheckIn = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgCheckIn.save(lAttDet.checkInDt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="5" class="py-0 pl-0">
        <v-dialog
        ref="dlgCheckInTime"
        persistent
        v-model="dlgCheckInTime"
        max-width="290px"
        :return-value.sync="lAttDet.checkInTime"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
          slot="activator"
          v-model="lAttDet.checkInTime"
          append-icon="mdi-calendar-clock"
          clearable
          readonly
          @input="lAttDet.checkInTime = null"
          v-on="on"
          ></v-text-field>
        </template>
        <v-time-picker v-model="lAttDet.checkInTime">
          <v-spacer></v-spacer>
          <v-btn text @click="dlgCheckInTime = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgCheckInTime.save(lAttDet.checkInTime)">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-col>
  </v-row>
  <v-row align="center">
    <v-col cols="7" class="py-0 pr-0">
      <v-dialog ref="dlgCheckOut"
      persistent v-model="dlgCheckOut"
      max-width="290px"
      :return-value.sync="lAttDet.checkOutDt"
      >
      <template v-slot:activator="{ on }">
        <v-text-field
        slot="activator" label="Check-out"
        v-model="lAttDet.checkOutDt"
        append-icon="mdi-calendar-today"
        readonly clearable
        v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="lAttDet.checkOutDt" scrollable
      first-day-of-week="1"
      :min="lAttDet.checkInDt"
      :max="handy.formatDBDate(lAttDet.checkOutMaxDt)"
      >
      <v-spacer></v-spacer>
      <v-btn text @click="dlgCheckOut = false">Cancel</v-btn>
      <v-btn text color="accent" @click="$refs.dlgCheckOut.save(lAttDet.checkOutDt)">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</v-col>
<v-col cols="5" class="py-0 pl-0">
  <v-dialog
  ref="dlgCheckOutTime"
  persistent
  v-model="dlgCheckOutTime"
  max-width="290px"
  :return-value.sync="lAttDet.checkOutTime"
  >
  <template v-slot:activator="{ on }">
    <v-text-field
    slot="activator"
    v-model="lAttDet.checkOutTime"
    append-icon="mdi-calendar-clock"
    clearable
    readonly
    @input="lAttDet.checkOutTime = null"
    v-on="on"
    ></v-text-field>
  </template>
  <v-time-picker v-model="lAttDet.checkOutTime">
    <v-spacer></v-spacer>
    <v-btn text @click="dlgCheckOutTime = false">Cancel</v-btn>
    <v-btn text color="accent" @click="$refs.dlgCheckOutTime.save(lAttDet.checkOutTime)">OK</v-btn>
  </v-time-picker>
</v-dialog>
</v-col>
</v-row>
<v-flex>
  <v-text-field
  v-model="lAttDet.remark"
  label="Remark"
  hide-details
  maxlength="50"
  >
</v-text-field>
</v-flex>
</v-card-text>
<v-card-actions class="pt-0">
  <v-spacer></v-spacer>
  <v-btn text @click.stop="dlgAttDet=false">Cancel</v-btn>
  <v-btn text type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-flex>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<!-- loading -->
<div v-if="load" style="position:absolute; top:50%; left:40%">
  <v-progress-circular indeterminate color="info"></v-progress-circular>
</div>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      lAction: 'view',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      pageRefKey: 0, // used to refresh page
      // component specific
      tab: 'tab-0',
      attTab: 'tab-0',
      tabitems: ['attendance', 'reports'],
      attTabItems: ['today', 'yesterday', 'week', 'month/period'],
      shifts: [],
      vendors: [],
      summary: [],
      shiftSummary: {},
      keyStaffs: [],
      attLog: [],
      attDet: [],
      lAttDet: '',
      lCurrentShiftId: '',
      lCurrentShift: '',
      lCurrentFrom: '',
      lCurrentTo: '',
      search: '',
      attHead: [
        { text: 'Role', value: 'staff_role', class: 'pa-3' },
        { text: 'Name', value: 'staff_name', class: 'pa-3' },
        { text: 'Attendance', value: 'attendance', class: 'pa-3' }
      ],
      attHeadSm: [
        { text: 'Date', value: 'att_dt', class: 'pa-2' },
        { text: 'Role', value: 'staff_role', class: 'pa-3' },
        { text: 'Name', value: 'staff_name', class: 'pa-3' },
        { text: 'Attendance', value: 'attendance', class: 'pa-3' },
        { text: 'Standby', value: 'standby', class: 'pa-3' },
        { text: 'Check-in', value: 'check_in', class: 'pa-3' },
        { text: 'Check-out', value: 'check_out', class: 'pa-3' },
        { text: 'Working-hours', value: 'effective_work_hours', class: 'pa-3' }
      ],
      keyStaffHead: [
        { text: 'Role', value: 'staff_role', class: 'pa-3' },
        { text: 'Name', value: 'staff_name', class: 'pa-3' },
        { text: 'Mobile', value: 'staff_mobile', class: 'pa-3' },
        { text: 'Attendance', value: 'attendance', class: 'pa-3' }
      ],
      keyStaffHeadSm: [
        { text: 'Date', value: 'att_dt', class: 'pa-3' },
        { text: 'Role', value: 'staff_role', class: 'pa-3' },
        { text: 'Name', value: 'staff_name', class: 'pa-3' },
        { text: 'Mobile', value: 'staff_mobile', class: 'pa-3' },
        { text: 'Attendance', value: 'attendance', class: 'pa-3' },
        { text: 'Standby', value: 'standby', class: 'pa-3' },
        { text: 'Check-in', value: 'check_in', class: 'pa-3' },
        { text: 'Check-out', value: 'check_out', class: 'pa-3' }
      ],
      attLogHead: [
        { text: 'In/Out', value: 'log_action', width: '30px' },
        { text: 'Time', value: 'log_time', width: '150px' },
        { text: 'Name', value: 'staff_name', width: '200px' }
      ],
      attLogHeadSm: [
        { text: 'In/Out', value: 'log_action' },
        { text: 'At', value: 'log_mode_and_loc' },
        { text: 'Time', value: 'log_time' },
        { text: 'Name', value: 'staff_name' },
        { text: 'Role', value: 'staff_role' }
      ],
      offlineDevHead: [
        { text: 'Name', value: 'staff_name', width: '100px' },
        { text: 'Deviation', value: 'offline_deviation', width: '200px' }
      ],
      offlineDevHeadSm: [
        { text: 'In/Out', value: 'log_action' },
        { text: 'At', value: 'log_mode_and_loc' },
        { text: 'Time', value: 'log_time' },
        { text: 'Name', value: 'staff_name' },
        { text: 'Deviation', value: 'offline_deviation', width: '375px' }
      ],
      dlgAttDet: false,
      dlgAttLog: false,
      dlgPeriodFrom: false,
      dlgPeriodTo: false,
      dlgCheckIn: false,
      dlgCheckInTime: false,
      dlgCheckOut: false,
      dlgCheckOutTime: false,
      // report
      filter: '',
      roles: [],
      dlgFromDt: '',
      dlgToDt: '',
      attReport: [],
      agreedDays: [],
      attReportDet: [],
      repHead: [
        { text: 'Role', value: 'staff_role', class: 'pa-2' },
        { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-center' },
        { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-center' }
      ],
      repHeadSm: [
        { text: 'Role [Headcount]', value: 'staff_role', class: 'pa-2' },
        { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-center', align: 'right' },
        { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-center', align: 'right' },
        { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-center', align: 'right' }
      ],
      repHeadCountSm: [
        { text: 'Role [Agreedcount]', value: 'staff_role', class: 'pa-2' },
        { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-xs-center', align: 'right' },
        { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-xs-center', align: 'right' },
        { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-xs-center', align: 'right' },
        { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-xs-center', align: 'right' },
        { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-xs-center', align: 'right' },
        { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-xs-center', align: 'right' },
        { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-xs-center', align: 'right' },
        { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-xs-center', align: 'right' }
      ],
      repDetCalHeadSm: [], // constructed dynamically
      repDetStaffHead: [
        { text: 'Staff', value: 'staff_name', class: 'pa-2' },
        { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-center' },
        { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-center' }
      ],
      repDetStaffHeadSm: [
        { text: 'Role', value: 'staff_role', class: 'pa-2' },
        { text: 'Staff', value: 'staff_name', class: 'pa-2' },
        { text: 'Emp ID', value: 'vendor_emp_id', class: 'pa-2', align: 'center' },
        { text: 'Present [a]', value: 'tot_present', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Weekoff [b]', value: 'tot_wo', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Holiday [c]', value: 'tot_holiday', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Standby/OT [d]', value: 'tot_ot', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Leave [e]', value: 'tot_leave', class: 'green--text pa-2 text-center', align: 'right' },
        { text: 'Absent', value: 'tot_absent', class: 'red--text pa-2 text-center', align: 'right' },
        { text: 'Agreement', value: 'tot_contracted', class: 'accent white--text pa-2 text-center', align: 'right' },
        { text: 'Billable [a+b+c+d+e]', value: 'tot_billable', class: 'success white--text pa-2 text-center', align: 'right' }
      ],
      vendorStandby: [],
      tempStandby: '',
      shiftNotRight: false,
      shiftOverride: false,
      commList: [],
      chosenComm: null,
      chosenCommPair: '',
      filterOfflineDev: false,
      offlineDevList: [],
      attNonBill: {},
      billableChip: ['Billable', 'Non-billable'],
      nonBillshiftSummary: {},
      lRep: {
        agreedHeadCount: false
      },
      enableChip: ''
    }
  },
  created () {
    this.loadCommunity()
    .then(res => {
      this.loadBasedOnchosenComm()
    })
  },
  mounted () {
    this.$forceUpdate()
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
    },
    loadCommunity () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID
          }
        }
        this.axios.get(config.API_URL + '/getCommunityByVendorId/', qry)
        .then(response => {
          this.commList = response.data
          this.chosenCommPair = {comm_id: this.commList[0].comm_id, comm_name: this.commList[0].comm_name}
          resolve(true)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.chosenCommPair = ''
          this.commList = []
          resolve(true)
        })
      })
    },
    loadBasedOnchosenComm () {
      this.chosenComm = this.chosenCommPair.comm_id
      this.loadShift()
      this.loadVendor()
      this.loadVendorEmp()
      .then(res => {
        this.refreshTab('attendance')
      })
    },
    showShift (curShiftId) {
      // change to chosen shift
      this.lCurrentShiftId = curShiftId
      this.lCurrentShift = this.shifts.find(rec => rec.shift_id === curShiftId).shift_abbr
      if (this.shiftSummary[curShiftId].detail && this.shiftSummary[curShiftId].detail.length > 0) {
        this.keyStaffs = this.shiftSummary[curShiftId].detail.filter(rec => rec.staff_role.includes('Helpdesk') ||
        rec.staff_role.includes('Facility') || rec.staff_role.includes('Supervisor') || rec.staff_role.includes('Manager') ||
        rec.staff_role.includes('Electrician') || rec.staff_role.includes('Plumber') || rec.staff_role.includes('Multi'))
        this.keyStaffs.forEach(rec => {
          if (rec.sby_vendor_emp_id) {
            rec.standby = this.vendorStandby.find(emp => emp.vendor_emp_id === rec.sby_vendor_emp_id).emp_name_and_id
          } else if (rec.sby_temp_staff_name) {
            rec.standby = rec.sby_temp_staff_name
          }
        })
      }
    },
    showShiftDet (curShiftId) {
      this.lCurrentShiftId = curShiftId
      this.lAction = 'att-det'
      this.loadNonBillableStaffs(curShiftId)
      this.refreshNonBillAttReportDet(this.filter.billable)
    },
    showAttLog () {
      // load log
      var qry = {
        params: {
          comm_id: this.chosenComm,
          from_dt: this.lCurrentFrom,
          to_dt: this.lCurrentTo,
          vendor_list: this.filter.vendor_list.map(rec => rec.vendor_id)
        }
      }
      this.attLog = []
      this.offlineDevList = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceLogByCommId/', qry)
      .then(response => {
        this.attLog = response.data
        this.offlineDevList = response.data.filter(rec => rec.offline_deviation)
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
      this.lAction = 'att-log'
    },
    prepareEditDet (curDet) {
      this.lAttDet = Object.assign({}, curDet)
      this.shiftNotRight = false
      this.shiftOverride = false
      if (!this.lAttDet.attendance) {
        this.lAttDet.attendance = ''
      }
      if (this.lAttDet.sby_vendor_emp_id) {
        this.lAttDet.sby_vendor_emp_pair = {vendor_emp_id: this.lAttDet.sby_vendor_emp_id, emp_name_and_id: this.vendorStandby.find(rec => rec.vendor_emp_id === this.lAttDet.sby_vendor_emp_id).emp_name_and_id}
      }
      if (this.lAttDet.check_in) {
        this.lAttDet.checkInDt = handy.formatDBDate(new Date(this.lAttDet.check_in))
        this.lAttDet.checkInTime = handy.getTime(new Date(this.lAttDet.check_in))
        this.lAttDet.prevCheckInDt = this.lAttDet.checkInDt
        this.lAttDet.prevCheckInTime = this.lAttDet.checkInTime
      } else {
        this.lAttDet.checkInDt = this.lAttDet.att_dt
      }
      if (this.lAttDet.check_out) {
        this.lAttDet.checkOutDt = handy.formatDBDate(new Date(this.lAttDet.check_out))
        this.lAttDet.checkOutTime = handy.getTime(new Date(this.lAttDet.check_out))
        this.lAttDet.prevCheckOutDt = this.lAttDet.checkOutDt
        this.lAttDet.prevCheckOutTime = this.lAttDet.checkOutTime
      } else {
        this.lAttDet.checkOutDt = this.lAttDet.checkInDt
      }
      this.lAttDet.checkInMinDt = new Date(this.lAttDet.att_dt)
      this.lAttDet.checkInMinDt.setDate(this.lAttDet.checkInMinDt.getDate() - 1)
      this.lAttDet.checkInMaxDt = this.lAttDet.att_dt
      this.lAttDet.checkOutMaxDt = new Date(this.lAttDet.att_dt)
      this.lAttDet.checkOutMaxDt.setDate(this.lAttDet.checkOutMaxDt.getDate() + 1)
      this.dlgAttDet = true
    },
    GetCheckOutDate (curCheckInDate) {
      // this.lAttDet.checkOutDt = curCheckInDate
      var tmpDt = new Date(curCheckInDate)
      this.lAttDet.checkOutMaxDt.setDate(tmpDt.getDate() + 1)
    },
    saveChanges () {
      // validate and save Changes
      if (!this.$refs.lForm.validate()) {
        return
      }
      if (this.lAttDet.attendance !== '' && this.lAttDet.attendance !== 'Absent' && this.lAttDet.attendance !== 'Comp Off' && this.lAttDet.attendance !== 'Holiday' && this.lAttDet.attendance !== 'Weekly Off' && !this.lAttDet.attendance.includes('Leave') || this.lAttDet.sby_vendor_emp_pair || this.lAttDet.sby_temp_staff_name) {
        if (!this.lAttDet.checkInDt || !this.lAttDet.checkInTime) {
          this.msg('Choose check-in date and time', true)
          return
        }
        if ((this.lAttDet.checkInDt === this.lAttDet.checkOutDt) && (this.lAttDet.checkInTime > this.lAttDet.checkOutTime)) {
          this.msg('Check-out time should be greater than check-in time', true)
          return
        }
        // ensure check-in time is with in shift window
        let chosenShift = this.shifts.find(rec => rec.shift_id === this.lAttDet.shift_id)
        let tmpShiftStart = new Date(this.lAttDet.att_dt + ' ' + chosenShift.start_time)
        let tmpCheckIn = new Date(this.lAttDet.checkInDt + ' ' + this.lAttDet.checkInTime)
        let hoursDiff = (tmpCheckIn - tmpShiftStart) / 1000 / 60 / 60
        if (Math.abs(hoursDiff) > config.ATTENDANCE_SHIFT_THRESHOLD && !this.shiftOverride) {
          this.shiftNotRight = true
          return
        }
      } else {
        this.lAttDet.checkInDt = null
        this.lAttDet.checkInTime = null
        this.lAttDet.checkOutDt = null
        this.lAttDet.checkOutTime = null
      }
      if (this.lAttDet.sby_vendor_emp_pair && this.lAttDet.sby_temp_staff_name) {
        this.msg('Both standby and temporary staff are not allowed at same time', true)
        return
      }

      var action = ''
      if (this.lAttDet.att_id) {
        action = 'update'
      } else {
        action = 'create'
      }

      this.beingSaved = true
      // preprocessing
      this.lAttDet.comm_id = this.chosenComm
      this.lAttDet.detail = []
      // record manual attendance if check-in/out times changed
      if (this.lAttDet.checkInDt && this.lAttDet.checkInTime && (this.lAttDet.checkInDt !== this.lAttDet.prevCheckInDt || this.lAttDet.checkInTime !== this.lAttDet.prevCheckInTime)) {
        this.lAttDet.detail.push({
          log_dt: handy.formatDBDateTime(new Date(this.lAttDet.checkInDt + ' ' + this.lAttDet.checkInTime)),
          log_action: 'IN',
          log_mode: 'Manual'
        })
      }
      if (this.lAttDet.checkOutDt && this.lAttDet.checkOutTime && (this.lAttDet.checkOutDt !== this.lAttDet.prevCheckOutDt || this.lAttDet.checkOutTime !== this.lAttDet.prevCheckOutTime)) {
        this.lAttDet.detail.push({
          log_dt: handy.formatDBDateTime(new Date(this.lAttDet.checkOutDt + ' ' + this.lAttDet.checkOutTime)),
          log_action: 'OUT',
          log_mode: 'Manual'
        })
      }

      // preprocessing
      if (this.lAttDet.attendance === 'Absent' || (this.lAttDet.attendance && this.lAttDet.attendance.includes('Leave')) || this.lAttDet.attendance === 'Weekly Off' || this.lAttDet.attendance === 'Holiday') {
        if (this.lAttDet.sby_vendor_emp_pair) {
          this.lAttDet.sby_vendor_emp_id = this.lAttDet.sby_vendor_emp_pair.vendor_emp_id
        } else {
          this.lAttDet.sby_vendor_emp_id = null
        }
      } else {
        // void the stand-by details in case entered accidentally
        this.lAttDet.sby_vendor_emp_id = null
        this.lAttDet.sby_temp_staff_name = null
      }
      this.axios.post(config.SMARTILITY_API_URL + '/attendance/' + action, this.lAttDet)
      .then(response => {
        // refresh list in front end
        setTimeout(() => {
          if (this.filter.billable === 'Billable') {
            this.loadAttSummary(this.filter.current_period, this.filter.billable)
          } else {
            this.refreshNonBillAttReportDet('Non-billable')
          }
          this.beingSaved = false
          this.dlgAttDet = false
        }, 500)
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    loadShift () {
      var qry = {
        params: {
          comm_id: this.chosenComm
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getShiftsByCommId/', qry)
      .then(response => {
        this.shifts = response.data
        this.lCurrentShiftId = this.shifts[0].shift_id // default shift
        // hightlight shift based on current system time
        var curTime = handy.getTime(new Date())
        this.shifts.forEach(rec => {
          this.shiftSummary[rec.shift_id] = [] // initialize for later use
          if (curTime >= rec.start_time && curTime <= rec.end_time) {
            this.lCurrentShiftId = rec.shift_id
            this.lCurrentShift = rec.shift_abbr
          }
        })
      })
      .catch(err => {
        this.msg(err, true)
        this.shifts = []
      })
    },
    loadVendor () {
      var qry = {
        params: {
          comm_id: this.chosenComm
        }
      }
      this.vendors = []
      this.axios.get(config.SMARTILITY_API_URL + '/getVendorByCommId/', qry)
      .then(response => {
        this.vendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadAttSummary (period = 'month/period', curChip) {
      this.filter.billable = curChip
      // load attendance summary for given period
      this.filter.current_period = period
      var curDate = new Date()
      if (period === 'today') {
        this.lCurrentFrom = curDate
        this.lCurrentTo = this.lCurrentFrom
      } else if (period === 'yesterday') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - 1)
        this.lCurrentTo = this.lCurrentFrom
      } else if (period === 'week') {
        this.lCurrentFrom = curDate.setDate(curDate.getDate() - (curDate.getDay() + 6) % 7)
        this.lCurrentTo = new Date()
      } else if (period === 'month/period') {
        this.lCurrentFrom = this.filter.from_dt
        this.lCurrentTo = this.filter.to_dt
      }
      this.lCurrentFrom = handy.formatDBDate(this.lCurrentFrom)
      this.lCurrentTo = handy.formatDBDate(this.lCurrentTo)
      curDate = this.handy.formatDBDate(curDate)
      var qry = {
        params: {
          comm_id: this.chosenComm,
          from_dt: this.lCurrentFrom,
          to_dt: this.lCurrentTo,
          vendor_list: this.filter.vendor_list.map(rec => rec.vendor_id),
          is_billable: curChip === 'Billable' ? 1 : 0
        }
      }
      this.shifts.forEach(rec => {
        this.shiftSummary[rec.shift_id] = []
      })
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceByCommId/', qry)
      .then(response => {
        this.summary = response.data
        // filter for each shift
        this.shifts.forEach(rec => {
          this.shiftSummary[rec.shift_id].start_time = rec.start_time
          this.shiftSummary[rec.shift_id].end_time = rec.end_time
          this.shiftSummary[rec.shift_id].detail = this.summary.filter(att => att.shift_id === rec.shift_id)
          this.shiftSummary[rec.shift_id].detail.forEach(rec => {
            rec.check_in = rec.check_in ? rec.check_in : ''
            rec.check_out = rec.check_out ? rec.check_out : ''
            if (rec.sby_vendor_emp_id) {
              rec.standby = this.vendorStandby.find(emp => emp.vendor_emp_id === rec.sby_vendor_emp_id).emp_name_and_id
            } else if (rec.sby_temp_staff_name) {
              rec.standby = rec.sby_temp_staff_name
            }
          })
          this.shiftSummary[rec.shift_id].totStaff = this.shiftSummary[rec.shift_id].detail.length
          this.shiftSummary[rec.shift_id].totPresent = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance && att.attendance.includes('Present')).length
          this.shiftSummary[rec.shift_id].totAbsent = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance === 'Absent').length
          this.shiftSummary[rec.shift_id].totLeave = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance && att.attendance.includes('Leave', 'Comp Off')).length
          this.shiftSummary[rec.shift_id].totWO = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance && att.attendance.includes('Weekly Off')).length
          this.shiftSummary[rec.shift_id].totHol = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance && att.attendance.includes('Holiday')).length
          this.shiftSummary[rec.shift_id].totOT = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance && (att.attendance.includes('OT') || att.standby)).length
          this.shiftSummary[rec.shift_id].totNotYetIn = this.shiftSummary[rec.shift_id].detail.filter(att => !att.attendance).length
          this.shiftSummary[rec.shift_id].totNotYetOut = this.shiftSummary[rec.shift_id].detail.filter(att => ((att.attendance !== 'Absent' && att.attendance !== 'Weekly Off' && att.attendance !== 'Holiday') || (att.standby || att.sby_temp_staff_name)) && att.check_in && !att.check_out).length
          // adjust half days
          this.shiftSummary[rec.shift_id].totHD = this.shiftSummary[rec.shift_id].detail.filter(att => att.attendance === 'Half Day').length
          this.shiftSummary[rec.shift_id].totPresent = this.shiftSummary[rec.shift_id].totPresent + (this.shiftSummary[rec.shift_id].totHD / 2)
          this.shiftSummary[rec.shift_id].totAbsent = this.shiftSummary[rec.shift_id].totAbsent + (this.shiftSummary[rec.shift_id].totHD / 2)
          this.shiftSummary[rec.shift_id].attAve = Math.round((this.shiftSummary[rec.shift_id].totPresent + this.shiftSummary[rec.shift_id].totOT + this.shiftSummary[rec.shift_id].totWO + this.shiftSummary[rec.shift_id].totHol) / (this.shiftSummary[rec.shift_id].totStaff) * 100)
        })
        this.showShift(this.lCurrentShiftId)
        this.$forceUpdate()
      })
      .catch(err => {
        this.summary = {}
        this.msg(err, true)
      })
    },
    loadVendorEmp () {
      return new Promise((resolve, reject) => {
        var qry = {
          params: {
            vendor_id: config.VENDOR_ID
          }
        }
        this.vendorStandby = []
        this.axios.get(config.SMARTILITY_API_URL + '/getEmpByVendorId/', qry)
        .then(response => {
          this.vendorStandby = response.data
          resolve(true)
        })
        .catch(err => {
          this.msg(err.response.data, true)
          resolve(true)
        })
      })
    },
    refreshAttReport (isAgreed = false, curChip) {
      this.enableChip = curChip
      this.loading()
      // number of reporting days
      var oneDay = 24 * 60 * 60 * 1000
      var fromDt = new Date(this.filter.from_dt)
      var toDt = new Date(this.filter.to_dt)
      this.filter.rep_days = Math.abs(Math.round((toDt.getTime() - fromDt.getTime()))) / oneDay + 1
      var qry = {
        params: {
          comm_id: this.chosenComm,
          from_dt: this.filter.from_dt,
          to_dt: this.filter.to_dt,
          vendor_list: this.filter.vendor_list.map(rec => rec.vendor_id),
          role_list: this.filter.role_list.map(rec => rec.staff_role_id),
          group_by: 'role',
          is_billable: this.enableChip === 'Billable' ? 1 : 0,
          is_agreed: isAgreed,
          vendor_id: config.VENDOR_ID
        }
      }
      this.attReport = []
      this.attReportDet = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceRep/', qry)
      .then(response => {
        this.attReport = response.data
        this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceAgreedDays/', qry)
        .then(res => {
          this.agreedDays = res.data
          // calculate few fields
          var idx = -1
          if (!isAgreed) {
            this.attReport.forEach(rec => {
              if (rec.is_part_time) {
                rec.tot_contracted = Number(rec.agreed_head_count) * Number(rec.agreed_days)
              } else {
                idx = this.agreedDays.findIndex(agr => agr.staff_role === rec.staff_role)
                if (idx >= 0) {
                  rec.tot_contracted = this.agreedDays[idx].agreed_days
                } else {
                  rec.tot_contracted = 0
                }
              }
              rec.staff_role = rec.staff_role + ' [' + rec.role_count + (rec.tot_contracted < (rec.role_count * this.filter.rep_days) ? '*' : '') + ']'
              rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
              rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
              rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave
            })
          } else {
            this.attReport.forEach(rec => {
              if (rec.is_part_time) {
                rec.tot_contracted = Number(rec.agreed_head_count) * Number(rec.agreed_days)
              } else {
                idx = this.agreedDays.findIndex(agr => agr.staff_role === rec.staff_role)
                if (idx >= 0) {
                  rec.tot_contracted = this.agreedDays[idx].tot_contracted
                } else {
                  rec.tot_contracted = 0
                }
              }
              rec.staff_role = rec.staff_role + ' [' + rec.agreed_head_count + ']'
              rec.tot_present = rec.tot_present + (rec.tot_hd / 2)
              rec.tot_absent = rec.tot_absent + (rec.tot_hd / 2)
              rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave
            })
          }
          this.load = false
          // attendance detail
          this.refreshAttReportDet(this.filter.billable)
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.load = false
      })
    },
    refreshAttReportDet (curChip) {
      this.filter.billable = curChip
      this.loading()
      // construct detail based on view chosen by user
      this.attReportDet = []
      var qry = {
        params: {
          comm_id: this.chosenComm,
          from_dt: this.filter.from_dt,
          to_dt: this.filter.to_dt,
          vendor_list: this.filter.vendor_list.map(rec => rec.vendor_id),
          role_list: this.filter.role_list.map(rec => rec.staff_role_id),
          order_by: 'date', // used if the api is getAttendanceByCommId
          is_billable: this.filter.billable === 'Non-billable' ? 0 : 1
        }
      }
      var apiName = this.filter.det_type === 'staff' ? 'getAttendanceRep' : this.filter.det_type === 'inOutSheet' ? 'getAttendanceInOutTimeRep' : 'getAttendanceByCommId'
      this.axios.get(config.SMARTILITY_API_URL + '/' + apiName + '/', qry)
      .then(response => {
        // calculate few fields
        if (this.filter.det_type === 'date' || this.filter.det_type === 'timesheet' || this.filter.det_type === 'inOutSheet') {
          // construct calendar view from retrived data for every staff
          var tmpStaffId = -1
          var idx = -1
          var dtIdx = 3
          var addedDates = []
          var tmpDt = ''
          var curAtt = ''
          var curDet = ''
          var sbyList = []
          this.repDetCalHeadSm = [
            { text: 'Role', value: 'staff_role', class: 'pa-2', columnWidth: (this.filter.det_type === 'timesheet' ? 13 : 20) },
            { text: 'Staff', value: 'staff_name', class: 'pa-2', columnWidth: (this.filter.det_type === 'timesheet' ? 16 : 30) },
            { text: 'Emp ID', value: 'vendor_emp_id', class: 'pa-2 text-center', align: 'center', columnWidth: (this.filter.det_type === 'timesheet' ? 8 : 10) },
            /* attendance for every calendar day added dynamically */
            { text: 'P', value: 'tot_present', class: 'green--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'W', value: 'tot_wo', class: 'green--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'H', value: 'tot_holiday', class: 'green--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'S/O', value: 'tot_ot', class: 'green--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'L', value: 'tot_leave', class: 'green--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'A', value: 'tot_absent', class: 'red--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 5 : 7) },
            { text: 'Billable', value: 'tot_billable', class: 'success white--text pa-2 text-center', align: 'right', columnWidth: (this.filter.det_type === 'timesheet' ? 9 : 11) }
          ]
          response.data.forEach(rec => {
            // 1. one line item per staff
            if (tmpStaffId !== rec.staff_id) {
              this.attReportDet.push({
                staff_id: rec.staff_id,
                staff_name: rec.staff_name,
                staff_role_id: rec.staff_role_id,
                staff_role: rec.staff_role,
                vendor_emp_id: rec.vendor_emp_id,
                calendar: [],
                tot_present: 0,
                tot_absent: 0,
                tot_wo: 0,
                tot_holiday: 0,
                tot_ot: 0,
                tot_hd: 0,
                tot_pend: 0,
                tot_billable: 0,
                tot_leave: 0
              })
              idx = this.attReportDet.length - 1
              tmpStaffId = rec.staff_id
            }
            curAtt = rec.attendance ? (rec.attendance === 'Half Day' ? 'HD' : rec.attendance === 'Casual Leave' ? 'CL' : rec.attendance === 'Sick Leave' ? 'SL' : rec.attendance === 'Earned Leave' ? 'EL' : rec.attendance === 'Present + RL' ? 'P+R' : rec.attendance.charAt(0)) : ''
            // 2. for summary
            if (curAtt) {
              if (rec.attendance.includes('Present')) {
                this.attReportDet[idx].tot_present++
              } else if (rec.attendance.includes('Absent')) {
                this.attReportDet[idx].tot_absent++
              } else if (rec.attendance.includes('Weekly Off')) {
                this.attReportDet[idx].tot_wo++
              } else if (rec.attendance.includes('Holiday')) {
                this.attReportDet[idx].tot_holiday++
              } else if (rec.attendance.includes('Leave') || (rec.attendance === 'Comp Off')) {
                this.attReportDet[idx].tot_leave++
              } else if (rec.attendance === 'Half Day') {
                this.attReportDet[idx].tot_hd++
                // adjust present and absent accordingly
                this.attReportDet[idx].tot_present += 0.5
                this.attReportDet[idx].tot_absent += 0.5
              }
              if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
                curAtt = curAtt + '+S'
              }
              // handle ot seperately
              if (rec.attendance.includes('OT')) {
                this.attReportDet[idx].tot_ot++
                curAtt = curAtt + '+O'
              }
              if (rec.attendance.includes('Present + RL')) {
                this.attReportDet[idx].tot_ot++
              }
              this.attReportDet[idx].tot_billable = this.attReportDet[idx].tot_present + this.attReportDet[idx].tot_wo + this.attReportDet[idx].tot_holiday + this.attReportDet[idx].tot_ot + this.attReportDet[idx].tot_leave
            } else {
              this.attReportDet[idx].tot_pend++
            }
            // 3. dynamic dates for table heading
            if (!addedDates.includes(rec.att_dt)) {
              addedDates.push(rec.att_dt)
            }
            // 4.1 attendance detail for table
            // add timesheet details if req
            if (this.filter.det_type === 'timesheet' && curAtt && (curAtt === 'P' || curAtt === 'HD' || curAtt.includes('+O') || curAtt.includes('+S') || curAtt.includes('P+R'))) {
              curDet = this.handy.getTime(rec.check_in)
              curDet += '\n' + (rec.check_out ? this.handy.getTime(rec.check_out) : '')
              curDet += '\n' + (rec.check_out ? ((this.handy.dateDiffInMins(new Date(rec.check_in), new Date(rec.check_out)) / 60).toFixed(1) + 'hrs') : '')
            } else if (this.filter.det_type === 'inOutSheet' && curAtt && (curAtt === 'P' || curAtt === 'HD' || curAtt.includes('+O') || curAtt.includes('+S') || curAtt.includes('P+R'))) {
              var det = rec.in_out_time ? rec.in_out_time.split(',').map(item => item.trim()) : ''
              curDet = det ? det.join('\n') : ''
            } else {
              curDet = ''
            }
            this.attReportDet[idx].calendar.push({
              att_dt: rec.att_dt,
              attendance: curAtt,
              att_detail: curAtt.includes('+S') ? '' : curDet
            })
            // 5. standby handling
            if (rec.sby_vendor_emp_id || rec.sby_temp_staff_name) {
              // add a line item for standby
              sbyList.push({
                sby_staff_id: rec.sby_vendor_emp_id || rec.sby_temp_staff_name,
                staff_name: rec.sby_vendor_emp_id ? this.vendorStandby.find(emp => emp.vendor_emp_id === rec.sby_vendor_emp_id).emp_name : rec.sby_temp_staff_name,
                staff_role_id: rec.staff_role_id,
                vendor_emp_id: rec.sby_vendor_emp_id || '',
                staff_role: rec.staff_role + ' [Sby]',
                tot_ot: 1,
                tot_billable: 1,
                calendar: [{att_dt: rec.att_dt, attendance: 'S', att_detail: curDet, tmp_dt: tmpDt}]
              })
            }
          })
          // post processing
          // sort dates in case
          addedDates = addedDates.sort()
          addedDates.forEach(dt => {
            // a.create dynamic column headers based on dates accumalated
            tmpDt = new Date(dt)
            tmpDt = this.filter.det_type === 'inOutSheet' ? tmpDt.toLocaleString('en-us', { month: 'short' }) + '-' + tmpDt.getDate() : tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1)
            this.repDetCalHeadSm.splice(dtIdx++, 0, {
              text: tmpDt, value: tmpDt, class: 'px-1 py-0 text-center', align: 'center', columnWidth: (this.filter.det_type === 'timesheet' ? 6 : 4)
            })
            // b. arrange attendance based on sorted dates
            this.attReportDet.forEach(det => {
              calDtIdx = det.calendar.findIndex(cal => cal.att_dt === dt)
              if (calDtIdx === -1) {
                curAtt = '-'
                curDet = ''
                det.calendar.push({att_dt: dt, attendance: curAtt})
              } else {
                curAtt = det.calendar[calDtIdx].attendance
                curDet = det.calendar[calDtIdx].att_detail
                det.calendar.push(det.calendar[calDtIdx])
                det.calendar.splice(calDtIdx, 1)
              }
              // detail for pdf/csv export
              det[tmpDt] = curAtt + (curAtt && curDet ? ('\n' + curDet) : '')
            })
          })
          // insert standbys at appropriate places (grouped by role)
          if (sbyList.length) {
            var roleSbyList = []
            var curStaffIdx = -1
            var roleStaffSbyList = []
            var roleIdx = -1
            var calDtIdx = -1
            handy.unique(sbyList.map(rec => rec.staff_role_id)).forEach(role => {
              // filter each role
              roleSbyList = sbyList.filter(sby => sby.staff_role_id === role)
              // group by staff
              roleSbyList.forEach(sby => {
                curStaffIdx = roleStaffSbyList.findIndex(rsby => rsby.sby_staff_id === sby.sby_staff_id)
                if (curStaffIdx >= 0) {
                  roleStaffSbyList[curStaffIdx].tot_ot++
                  roleStaffSbyList[curStaffIdx].tot_billable++
                  roleStaffSbyList[curStaffIdx].calendar.push(sby.calendar[0])
                  roleStaffSbyList[curStaffIdx][sby.calendar[0].tmp_dt] = 'S' // for pdf/csv
                } else {
                  roleStaffSbyList.push(sby)
                }
              })
              // fill-in attendance for non standby dates for every staff
              roleStaffSbyList.forEach(rsby => {
                // a. fill-in attendance for non standby dates
                addedDates.forEach(dt => {
                  tmpDt = new Date(dt)
                tmpDt = this.filter.det_type === 'inOutSheet' ? tmpDt.toLocaleString('en-us', { month: 'short' }) + '-' + tmpDt.getDate() : tmpDt.getDate() + '/' + (tmpDt.getMonth() + 1)
                  calDtIdx = rsby.calendar.findIndex(cal => cal.att_dt === dt)
                  if (calDtIdx === -1) {
                    curAtt = '-'
                    curDet = ''
                    rsby.calendar.push({att_dt: dt, attendance: curAtt})
                  } else {
                    curAtt = 'S'
                    curDet = rsby.calendar[calDtIdx].att_detail
                    rsby.calendar.push(rsby.calendar[calDtIdx])
                    rsby.calendar.splice(calDtIdx, 1)
                  }
                  rsby[tmpDt] = curAtt + (curDet ? ('\n' + curDet) : '') // for pdf/csv
                })
              })
              // insert all these staff records at appropriate place in main attendance (end of concerned group)
              roleIdx = this.attReportDet.map(rep => rep.staff_role_id).lastIndexOf(role)
              this.attReportDet.splice(roleIdx + 1, 0, ...roleStaffSbyList)
              roleStaffSbyList = []
            }) // for ever role
          }
        } else {
          this.attReportDet = response.data
          this.attReportDet.forEach(rec => {
            rec.tot_present = rec.tot_present ? rec.tot_present + (rec.tot_hd / 2) : 0
            rec.tot_absent = rec.tot_absent ? rec.tot_absent + (rec.tot_hd / 2) : 0
            rec.tot_contracted = rec.tot_contracted ? rec.tot_contracted : 0
            rec.tot_ot = rec.tot_ot ? rec.tot_ot : 0
            rec.tot_wo = rec.tot_wo ? rec.tot_wo : 0
            rec.tot_holiday = rec.tot_holiday ? rec.tot_holiday : 0
            rec.tot_leave = rec.tot_leave ? rec.tot_leave : 0
            rec.vendor_emp_id = rec.vendor_emp_id ? rec.vendor_emp_id : '-'
            rec.tot_billable = rec.tot_present + rec.tot_wo + rec.tot_holiday + rec.tot_ot + rec.tot_leave
          })
        }
        this.pageRefKey++ // forces the detail table to re-render
        this.$forceUpdate()
        this.load = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.load = false
      })
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: this.chosenComm
        }
      }
      // list of available roles
      this.axios.get(config.SMARTILITY_API_URL + '/getStaffRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.roles = []
      })
    },
    loadNonBillableStaffs (curShiftId = null) {
      var qry = {
        params: {
          comm_id: this.chosenComm,
          tab: this.tab,
          shift_id: curShiftId
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getNonBillableStaffs/', qry)
      .then(response => {
        this.attNonBill.tot_nonbillable_staff = response.data[0].tot_nonbillable_staff
        if (this.attNonBill.tot_nonbillable_staff === 0) {
          this.filter.billable = 'Billable'
        }
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadNonBillStaffasSby (curAttDet) {
      if (curAttDet.attendance === 'Absent' || curAttDet.attendance === 'Comp Off' || curAttDet.attendance === 'Weekly Off' || curAttDet.attendance === 'Holiday' || curAttDet.attendance.includes('Leave')) {
        var qry = {
          params: {
            comm_id: this.chosenComm,
            vendor_id: config.VENDOR_ID,
            staff_role_id: curAttDet.staff_role_id,
            from_dt: curAttDet.att_dt
          }
        }
        this.axios.get(config.SMARTILITY_API_URL + '/getNonBillableEmpForSby/', qry)
        .then(response => {
          var nonBillableStaff = response.data
          for (var i = 0; i < nonBillableStaff.length; i++) {
            if ((handy.formatDBDateTime(nonBillableStaff[i].check_in)) && (nonBillableStaff[i].check_out === null)) {
              this.lAttDet.sby_vendor_emp_pair = { vendor_emp_id: nonBillableStaff[i].vendor_emp_id, emp_name_and_id: nonBillableStaff[i].emp_name_with_id }
              this.lAttDet.checkInTime = handy.getTime(nonBillableStaff[i].check_in)
              i = nonBillableStaff.length
            }
          }
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, true)
        })
      } else {
        this.lAttDet.sby_vendor_emp_pair = {}
      }
    },
    refreshNonBillAttReportDet (curChip) {
      this.filter.billable = curChip
      if (curChip === 'Non-billable') {
        var qry = {
          params: {
            comm_id: this.chosenComm,
            from_dt: this.lCurrentFrom,
            to_dt: this.lCurrentTo,
            vendor_list: this.filter.vendor_list.map(rec => rec.vendor_id),
            shift_id: this.lCurrentShiftId,
            is_billable: 0
          }
        }
        this.nonBillshiftSummary[this.lCurrentShiftId] = []
        this.axios.get(config.SMARTILITY_API_URL + '/getAttendanceByCommId/', qry)
        .then(response => {
          this.nonBillshiftSummary[this.lCurrentShiftId] = response.data
          this.$forceUpdate()
        })
        .catch(err => {
          this.nonBillshiftSummary = {}
          this.msg(err.response.data, true)
        })
      } else {
        this.loadAttSummary(this.filter.current_period, curChip)
      }
    },
    refreshTab (curTab) {
      var curDate = new Date()
      if (!this.filter) {
        this.filter = {
          current_period: 'today',
          vendor_list: [],
          role_list: [],
          from_dt: handy.formatDBDate(new Date(curDate.getFullYear(), curDate.getMonth(), 1)),
          to_dt: handy.formatDBDate(curDate),
          det_type: 'date'
        }
      }
      this.filter.billable = 'Billable'
      if (curTab === 'reports') {
        this.loadRoles()
      }
      // load report for the entire month by default if user going to report tab first time
      if (curTab === 'attendance') {
        this.tab = 'tab-0'
        this.loadAttSummary(this.filter.current_period, this.filter.billable)
      } else {
        this.tab = 'tab-1'
        this.refreshAttReport(null, 'Billable')
        this.loadNonBillableStaffs()
      }
      this.lAction = 'view'
    }
  }
}
</script>
